<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!loading" class="content-wrapper">
    <div class="container">
      <article>

        <section class="section white-panel mb8">
          <h2 class="fs18 text-center mt4 mb12">コスモでガソリンが会員価格に。<br>充実の会員特典！</h2>
          <p class="mb0 text-center">
            <img src="/lib/images/aeon_cosmo_the_card_opus_waon_3images.png" class="w100p" alt="">
          </p>
        </section>

        <div class="border-solid-gray bg-white radius16 pt12 pd4 ml12 mr12 mt2p mb0">
            <p class="fs13 mt4 mb4 text-center">コスモ・ザ・カード・オーパスのお申し込みはこちら。
<br>※書類の郵送･お届け印不要。</p>
          <p class="fs16 mt4 mb4 text-center font-weight-bold">
            ＼オンラインで完結／
          </p>
          <div class="transparent-panel">
            <button v-on:click="jsOpenBrowser('https://www.aeon.co.jp/application/cosmo/?cit=OP-03&scd=9999' + mySsCord, 'OPEN_AEON_PAGE', { 'tappedSsCode':mySsCord })" class="button fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
          </div>
        </div>
            <p class="fs32 mt16 mb8 text-center color-blue1 font-weight-bold">▼新規入会特典▼</p>

        <section class="section white-panel pl0 pr0">
          <p class="mb0 text-center">
            <img src="/lib/images/aeon_cosmo_the_card_opus_waon_bonus_01.png" class="w100p" alt="">
          </p>
        </section>
        <p class="fs40 mt16 mb8 text-center color-blue1 font-weight-bold">さらに！<br><img src="/lib/images/aeon_cosmo_the_card_opus_plus_button.png" class="w15p" alt=""></p>

        <section class="section white-panel pl0 pr0">
          <p class="mb0 text-center">
            <img src="/lib/images/aeon_cosmo_the_card_opus_waon_bonus_02.png" class="w100p" alt="">
          </p>
        </section>

        <div class="transparent-panel mt16">
          <button v-on:click="jsOpenBrowser('https://www.aeon.co.jp/application/cosmo/?cit=OP-03&scd=9999' + mySsCord, 'OPEN_AEON_PAGE', { 'tappedSsCode':mySsCord })" class="button fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
        </div>

        <section class="section white-panel pl0 pr0">
          <div class="bg-grad-blue pt16">
            <h2 class="fs18 mt4 mb12 pl12 color-white">特典</h2>
            <ul class="list-special ml12 mr12">
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">１</span></p>
                <p class="fs16 font-weight-bold mb0"><span class="color-blue3">入会金・年会費0円！</span><br>あんしんの盗難紛失保障付！</p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">２</span></p>
                <p class="fs16 font-weight-bold mb0 line-height1_2">無料で発行！<br>
                  コスモ・ザ・カードオーパスのETCカードご利用で<span class="color-blue3">WAON POINT基本の3倍！</span><br>
                <span class="fs10 line-height1_2 inline-block">※適用には条件がございます。<br>※基本とは、200円(税込)ごとに1WAON POINT進呈をさします。</span></p>
              </li>
              <li class="">

                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">３</span></p>
                <p class="fs16 font-weight-bold mb0 line-height1_2">会員価格でガソリンがおトクに！
                <br><span class="fs10 line-height1_2 inline-block">※会員価格とならない店舗もございますので、<br>店舗にて価格をご確認ください。</span></p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">４</span></p>
                <p class="fs16 font-weight-bold mb0">カードご利用額に応じて<br>
                  <span class="color-blue3">「WAON POINT」</span>がたまります。<br>
                  たまった「WAON POINT」は給油時にご利用できます。
                <br><span class="fs11 line-height1_2 inline-block">※一部ご利用いただけない店舗がございます</span></p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">５</span></p>
                <p class="fs16 font-weight-bold mb0">アプリにカードを登録すると<br>
                お使いのSSのガソリン価格がアプリからわかる。</p>              </li>
            </ul>
          </div>
        </section>
        <div class="transparent-panel mt16">
          <button v-on:click="jsOpenBrowser('https://www.aeon.co.jp/application/cosmo/?cit=OP-03&scd=9999' + mySsCord, 'OPEN_AEON_PAGE', { 'tappedSsCode':mySsCord })" class="button fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
        </div>
        <p class="text-center ttl-ribon-eco"><img src="/lib/images/ttl-ribon-eco.png" class="w80p" alt="コスモ･ザ･カード･オーパス「エコ」"></p>

        <div class="border-solid-gray bg-white radius16 pt48 pd4 ml12 mr12 mt0 mb0">
            <p class="mb16 text-center"><img src="/lib/images/aeon_cosmo_the_card_opus_ecowaon_v_f_rgb.png" class="w60p" alt=""></p>
            <p class="fs14 mt4 mb16 text-center card-info-text">コスモ･ザ･カード･オーパス「エコ」の特典に加え、<br>
            毎年お客さまからお預かりする500円と<br>
            コスモ石油からの寄付金をNPOや公益法人などに<br>
            寄付することでその活動をサポートしていきます。</p>
            <p class="fs12 text-center card-info-text-sub">コスモ･ザ･カード･オーパス「エコ」のお申込みはこちら。<br>
            ※書類の郵送・お届け印不要。</p>
          <div class="transparent-panel">
            <button v-on:click="jsOpenBrowser('https://www.aeon.co.jp/application/cosmoeco/?cit=OP-03&scd=9999' + mySsCord, 'OPEN_AEON_ECOPAGE', { 'tappedSsCode':mySsCord })" class="button fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
          </div>
        </div>
        <section class="section white-panel mb8 mt16">
          <table class="table card-info">
            <tbody>
              <tr>
                <th rowspan="2">国際ブランド</th>
                <td width="70">オーパス</td>
                <td>
                  <div class="flex">
                  <img src="/lib/images/card-brand-visa.png" class="fl mr3p" alt="">
                  <img src="/lib/images/card-brand-master.png" class="fl mr3p" alt="">
                  <img src="/lib/images/card-brand-jcb.png" class="" alt="">
                  </div>
                </td>
              </tr>
            <tr>
              <td>エコ</td>
              <td>
                <div class="flex">
                  <img src="/lib/images/card-brand-visa.png" class="fl" alt="">
                </div>
              </td>
            </tr>
            <tr>
              <th width="">追加可能カード・<br>サービス</th>
              <td colspan="2">
                <div class="flex"><span class="label em mr3p">ETCカード</span> <span class="label em mr3p">家族カード</span> <span class="label em">Apple Pay</span></div></td>
            </tr>
            <tr>
              <th>付帯保険</th>
              <td colspan="2">カード盗難保障無料付帯</td>
            </tr>
            </tbody>
          </table>
        </section>
        <!-- カードスペック選択画面に戻るボタン -->
        <form name="fm">
          <input id="tsid" type="hidden" name="tsid" v-bind:value="this.nativeData.tsid">
          <input id="otoken" type="hidden" name="otoken" v-bind:value="this.nativeData.otoken">
          <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionData.appVersion">
          <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionData.platform">
          <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionData.osVersion">
        </form>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import profileApi from '@/store/Api/Common/profile'
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'

export default {
  data () {
    return {
      loading: true,
      mySsCord: '',
      profileInfo: []
    }
  },
  methods: {
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    jsOpenBrowser: function (url, type, customParameters) {
      // 今すぐお申込みボタン
      if (type === 'OPEN_AEON_PAGE') {
        this.nativeEVENTSet('CardNyukaiButton', type, 'TAP', customParameters)
      }
      // 今すぐお申込みボタン ECO
      if (type === 'OPEN_AEON_ECOPAGE') {
        this.nativeEVENTSet('EcoCardNyukaiButton', type, 'TAP', customParameters)
      }
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.appDisplayTitle('コスモ・ザ・カード')
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
      this.mySsCord = res.data.body.best_myss.code
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // [eventTrack] カードスペック画面表示完了
    this.nativePVset('CARD_NYUKAI_SOKUSHIN')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}

</script>
